<template>
	<div>
		<div v-show="!updateExists">
			<div v-if="!pageOptions.pageEmpty" class="fade page-sidebar-fixed page-header-fixed show page-container"
				v-bind:class="{ 
		'page-sidebar-minified': pageOptions.pageSidebarMinified, 
		'page-content-full-height': pageOptions.pageContentFullHeight, 
		'page-without-sidebar': pageOptions.pageWithoutSidebar, 
		'page-with-right-sidebar': pageOptions.pageWithRightSidebar, 
		'page-with-two-sidebar': pageOptions.pageWithTwoSidebar,
		'page-with-wide-sidebar': pageOptions.pageWithWideSidebar,
		'page-with-light-sidebar': pageOptions.pageWithLightSidebar,
		'page-with-top-menu': pageOptions.pageWithTopMenu,
		'page-sidebar-toggled': pageOptions.pageMobileSidebarToggled,
		'page-right-sidebar-toggled': pageOptions.pageMobileRightSidebarToggled || pageOptions.pageRightSidebarToggled,
		'page-right-sidebar-collapsed': pageOptions.pageRightSidebarCollapsed,
		'has-scroll': pageOptions.pageBodyScrollTop
	}">
				<Header />
				
				<TopMenu v-if="pageOptions.pageWithTopMenu" />
				<Sidebar v-if="!pageOptions.pageWithoutSidebar" />
				<SidebarRight v-if="pageOptions.pageWithTwoSidebar" />
				<div id="content" class="content"
					v-bind:class="{ 'content-full-width': pageOptions.pageContentFullWidth, 'content-inverse-mode': pageOptions.pageContentInverseMode }">
					
					<router-view></router-view>
					<vue-ins-progress-bar></vue-ins-progress-bar>
				</div>
				<Footer v-if="pageOptions.pageWithFooter" />
			</div>
			<div v-else>
				<router-view></router-view>
				<vue-ins-progress-bar></vue-ins-progress-bar>
			</div>
		</div>
		<div v-show="updateExists" class="row">
			<div class="col-lg-12">
				<div class="coming-soon">
					<div class="coming-soon-header">
						<div class="bg-cover"></div>
						<div class="brand">
							<img :src="URL_WEB()+'views/public_xhtml/img/logos/logo-footer.png'" alt="Juru" style="max-width: 260px">
						</div>
						<div class="desc">
							Existe una nueva versión disponible del <b> App Automotriz Juru</b> y necesita ser actualizado.
						</div>
					</div>
					<div class="coming-soon-content">
						<div class="desc">
							Hemos actualizado el App, disfrute de la nueva versión.
						</div>
						<div class="input-group">
							<button type="button" class="btn btn-warning btn-block  btn-lg" @click="refreshApp">
								<i class="fas fa-sync"></i> Haga click para actualizar
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Sidebar from './components/sidebar/Sidebar.vue'
	import SidebarRight from './components/sidebar-right/SidebarRight.vue'
	import Header from './components/header/Header.vue'
	import TopMenu from './components/top-menu/TopMenu.vue'
	import Footer from './components/footer/Footer.vue'
	import PageOptions from './config/PageOptions.vue'
	import {
		store
	} from './store';
	export default {
		//   name: 'app',
		name: 'DefaultContainer',
		components: {
			Sidebar,
			SidebarRight,
			Header,
			TopMenu,
			Footer
		},
		data() {
			return {
				pageOptions: PageOptions
			}
		},
		methods: {
			handleScroll: function () {
				PageOptions.pageBodyScrollTop = window.scrollY;
			}
		},
		beforeMount: function () {
			if (!store.state.auth) {
				this.$router.push('/login');
			}
		},
		mounted() {
			this.$insProgress.finish()
			if (this.updateExists) {
				this.refreshApp();
			}
		},
		created() {
			PageOptions.pageBodyScrollTop = window.scrollY;
			window.addEventListener('scroll', this.handleScroll);
			this.$insProgress.start()
			this.$router.beforeEach((to, from, next) => {
				this.$insProgress.start()
				next()
			})
			this.$router.afterEach(() => {
				this.$insProgress.finish()
			})
		}
	}
</script>